import { useEffect, useState } from "react";
import request from "superagent";
import { BACKEND_URL } from "../config/config";
import { Theme } from "../types/Theme";

export default function useAdaptiveTheme(
  type: "baselayer" | "layer",
  uuid: string
) {
  const [theme, setTheme] = useState<Theme>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const req = request.get(
      BACKEND_URL +
        "api/content/" +
        (type === "baselayer" ? "basethemes" : "themes") +
        "/" +
        uuid
    );

    setError(false);
    setLoading(true);

    req
      .then((res) => {
        setLoading(false);
        setTheme(res.body);
      })
      .catch((err) => {
        if (err.code === "ABORTED") return;
        console.log(err);
        setLoading(false);
        setError(true);
      });

    return () => req.abort();
  }, [type, uuid]);

  return { theme, loading, error };
}
